import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import { Management, Avatar, Plus } from "@element-plus/icons-vue";
import { AddUserApi, GetClassByCodeApi } from "@/api/userManagementApi.js";
import { reactive } from "vue";
import { ElMessage, ElLoading, ElMessageBox } from "element-plus";
import { getTimeText } from "@/assets/js/tool";
export default {
  name: "user-info",
  setup() {
    let userInfo = reactive({});
    let classInfo = reactive([]);
    const loading = ElLoading.service({
      lock: true,
      text: "加载中..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    function getUserInfo() {
      if (window.localStorage.getItem("gz-userInfo")) {
        let obj = JSON.parse(window.localStorage.getItem("gz-userInfo"));
        Object.assign(userInfo, obj);
        getClassInfo();
      } else {
        setTimeout(() => {
          getUserInfo();
        }, 2000);
      }
    }
    function getClassInfo() {
      loading.close();
      if (userInfo.classes) classInfo.push(...userInfo.classes);

      // if (userInfo.clazzIds) {
      //   userInfo.clazzIds.forEach((item) => {
      //     if (item) {
      //       GetClassByIdApi(item).then((r) => {
      //         if (r.status < 400) {
      //           classInfo.push(r.data);
      //         } else {
      //           ElMessage({
      //             type: "error",
      //             showClose: true,
      //             message: r.msg,
      //           });
      //         }
      //       });
      //     }
      //   });
      // }
    }
    function addClass() {
      ElMessageBox.prompt("请输入班级编号", "加入班级", {
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(({
        value
      }) => {
        AddUserApi({
          clazzId: value,
          userIds: [userInfo.id]
        }).then(r => {
          if (r.status < 400) {
            ElMessage({
              type: "success",
              showClose: true,
              message: "加入成功"
            });
            GetClassByCodeApi(value).then(r => {
              if (r.status < 400) {
                classInfo.push(r.data[0]);
              } else {
                ElMessage({
                  type: "error",
                  showClose: true,
                  message: r.msg
                });
              }
            });
          } else {
            ElMessage({
              type: "error",
              showClose: true,
              message: r.msg
            });
          }
        });
      }).catch(() => {});
    }
    getUserInfo();
    return {
      getTimeText,
      Plus,
      userInfo,
      Management,
      Avatar,
      classInfo,
      addClass
    };
  }
};